<div
  class="relative w-full bg-white rounded-lg p-4 flex flex-col max-h-[850px]"
  [class]="styleClass()"
>
  @if(isLoading()) {
  <div
    class="absolute inset-0 z-10 flex items-center justify-center rounded-lg backdrop-blur-md bg-white/30"
  >
    <span class="text-blue-400 text-lg font-semibold select-none">
      <fa-icon [icon]="loadingIcon" [animation]="'spin-pulse'"></fa-icon>
      Carregando...
    </span>
  </div>
  }
  <div class="shrink-0">
    <div class="flex justify-between items-center relative z-0">
      <h2 class="text-xl md:text-2xl text-gray-400">{{ title() }}</h2>
      <ng-content select="[card-button]"></ng-content>
    </div>
    <hr class="my-4 border-gray-300" />
  </div>
  <div class="flex-1 min-h-0 overflow-y-auto">
    <ng-content></ng-content>
  </div>
  <div class="shrink-0">
    <ng-content select="[paginator]"></ng-content>
  </div>
</div>
